import { Component, OnDestroy, OnInit } from '@angular/core';
import { faSolarPanel, faWind } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { CustomerDataService } from 'src/app/services/customer-data.service';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit, OnDestroy {
  constructor(private cdService: CustomerDataService, private firebase: FirebaseService) { }
  public companiesData: any = [];
  customerWiseData: any = {};
  customerOriginalWiseData: any = {};
  filter = true;
  lastUpdated = '';
  totalSites = 0;
  activeSites = 0
  customerwiseActive: any = {}
  isTabActive = false;
  interval: any;
  faSolarIcon = faSolarPanel;
  faWindIcon = faWind;
  ngOnInit(): void {
    this.cdService.isTabActive$.subscribe(isTabActive => {
      this.isTabActive = isTabActive;
    });
    this.cdService.message.subscribe(data => {
      this.companiesData = data
      //console.log(this.companiesData)
    })
    this.loadData();
    this.interval = setInterval(() => {
      if (this.isTabActive) {
        this.loadData();
      }
    }, 1000 * 60);
  }
  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  loadData() {
    console.log('load data called')
    this.customerOriginalWiseData = {};
    this.customerwiseActive = {};
    this.totalSites = 0;
    this.activeSites = 0
    this.firebase.listenSiteLiveStatus().then((data) => {
      console.log(data, 'status data')
      if (data && Object.keys(data).length) {
        this.lastUpdated = moment().format("YYYY-MMM-DD HH:mm:ss");
        for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            const [constomer, siteId] = key.split('-');
            if (!this.customerwiseActive[constomer]) {
              this.customerwiseActive[constomer] = {
                active: 0,
                total: 0
              };
            }
            this.customerwiseActive[constomer].total++;
            this.totalSites++
            if (!data[key].d) {
              this.customerwiseActive[constomer].active++;
              this.activeSites++;
            }
            if (!this.customerOriginalWiseData[constomer]) {
              this.customerOriginalWiseData[constomer] = {};
            }
            if (!this.customerOriginalWiseData[constomer].sites) {
              this.customerOriginalWiseData[constomer].sites = [];
            }
            this.customerOriginalWiseData[constomer].sites.push({ ...data[key], siteId });
            /*  this.customerOriginalWiseData[constomer].sites.push({ ...data[key], siteId });
             this.customerOriginalWiseData[constomer].sites.push({ ...data[key], siteId });
             this.customerOriginalWiseData[constomer].sites.push({ ...data[key], siteId });
             this.customerOriginalWiseData[constomer].sites.push({ ...data[key], siteId });
             this.customerOriginalWiseData[constomer].sites.push({ ...data[key], siteId }); */
          }

        }
      }
      this.onFilterChange()
    })
  }
  onFilterChange() {
    if (this.filter) {
      this.customerWiseData = { ...this.customerOriginalWiseData };
    } else {
      this.customerWiseData = {};
      for (const constomer in this.customerOriginalWiseData) {
        if (this.customerOriginalWiseData[constomer] && this.customerOriginalWiseData[constomer].sites && this.customerOriginalWiseData[constomer].sites.length) {
          if (!this.customerWiseData[constomer]) {
            this.customerWiseData[constomer] = {};
          }
          if (!this.customerWiseData[constomer].sites) {
            this.customerWiseData[constomer].sites = this.customerOriginalWiseData[constomer].sites.filter((s: any) => s.d);
          }
        }
      }
    }

  }
}
